const recipeData = [
  {
    id: "1",
    title: "Healthy Breakfast Within 5 Minutes",
    category: "Egg",
    video: "https://www.youtu.be/3uzTj92MY34",
    width: "440px",
    height: "230px",
    desc: "Healthy Breakfat that give you full energy to start your day, the most important meal of the day.",
  },
  {
    id: "2",
    title: "Authentic Traditional Chicken Korma",
    category: "Non Veg",
    video: "https://www.youtu.be/kudzJYjPHoQ",
    width: "440px",
    height: "230px",
    desc: "Chicken Korma is a traditional Mughlai dish where chicken is cooked with spices, onion paste, yogurt and nuts.",
  }/* ,
  {
    id: "3",
    title: "",
    category: "Veg",
    video: "",
    width: "",
    height: "",
    desc: "",
  },
  {
    id: "4",
    title: "",
    category: "Healthy Recipe",
    video: "",
    width: "",
    height: "",
    desc: "",
  } */
];

export default recipeData;
